// helpers.tsx
import { Link } from "@mui/material";
import { TbShirtSport } from "react-icons/tb";
import { HiOutlineTicket } from "react-icons/hi";
import { MdOutlineEventSeat, MdOutlinedFlag } from "react-icons/md";

export const purchaseSeatsLanguages = {
  similarSeatModalBody: (seatTitle: string) => {
    return <>We are going to find similar seats for all games in your pack.</>;
  },
};

export const howItWorks = [
  {
    icon: <MdOutlinedFlag />,
    title: "Choose Your Games",
    description: "Select the games you wish to attend.",
  },
  {
    icon: <MdOutlineEventSeat />,
    title: "Login to Account Manager",
    description:
      " Click Continue and connect your Nashville Predators account using our secure Ticketmaster login.",
  },
  {
    icon: <TbShirtSport />,
    title: "Select Your Seats",
    description: "Select the seats you wish to purchase for each game.",
  },

  {
    icon: <HiOutlineTicket />,
    title: "Get Your Tickets",
    description:
      "Tickets will be available in your Account Manager within 24 hours of redemption. Reach out to Live Fan Support for any questions.",
  },
];

export const faqs = [
  {
    title: "How does the Nashville Predators Santa Experience program work?",
    description:
      "The Nashville Predators Santa Experience program allows fans to select 2 upper level or lower level seats to the above games. This also includes a $10 Gnash Cash per seat. Simply log into your Nashville Predators Account Manager and select games.",
  },
  {
    title: "Do I have to select all my games now?",
    description: "Yes, you must select all games at the time of purchase.",
  },
  {
    title: "Can I choose seats throughout the venue?",
    description: "Yes, you can choose from all current available inventory.",
  },
  {
    title: "Where are event tickets delivered?",
    description:
      "Event tickets are delivered directly within your Nashville Predators Account Manager.",
  },
];

export function TermsAndCondition() {
  return (
    <>
      By purchasing you agree to receive SMS alerts regarding ticket delivery
      and agree to the{" "}
      <Link
        // fontWeight={"bold"}
        // textDecor="underline"

        href={
          "https://uploads-ssl.webflow.com/5ed7df6fe67e862e0a62f9f2/616882d2b691e09f75348396_Terms%20%26%20Conditions.pdf"
        }
        target={"_blank"}
        sx={{
          color: "primary.main",
          textDecoration: "none",
          fontWeight: 500,
        }}
      >
        Terms & Conditions
      </Link>{" "}
      and{" "}
      <Link
        // fontWeight={"bold"}
        // textDecor="underline"
        href={
          "https://uploads-ssl.webflow.com/5ed7df6fe67e862e0a62f9f2/63c05d80816dac05b5b34ac7_seasonshare%20CCPA%20Privacy%20Policy%20Agreement.pdf"
        }
        target={"_blank"}
        sx={{
          color: "primary.main",
          textDecoration: "none",
          fontWeight: 500,
        }}
      >
        Privacy Policy
      </Link>
      .
    </>
  );
}
